import SectionHeader from "@/components/gala/SectionHeader";
import { RSVP_URL, EVENT } from "@/lib/eventData";
import { ArrowUpRight, PartyPopper, Calendar, MapPin } from "lucide-react";
import { Mojito, Cigar, Hibiscus } from "@/components/gala/TropicalDecor";

export default function RSVPForm() {
  return (
    <section
      id="rsvp"
      data-testid="rsvp-section"
      className="section relative overflow-hidden"
    >
      {/* Tropical decor */}
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
        <Mojito className="absolute top-16 left-8 w-32 sm:w-40 text-[#F3E08A]/16" />
        <Cigar className="absolute bottom-20 right-8 w-52 sm:w-64 text-[#D9C7A0]/12 -rotate-3" />
        <Hibiscus className="absolute top-40 right-16 hidden lg:block w-36 text-[#EBDDBF]/12 rotate-45" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <SectionHeader
          eyebrow="Your Invitation"
          title="RSVP for the Year-End Function"
          description="Kindly let us know if you'll be joining us. RSVPs are handled through our Microsoft Forms link — quick, secure and it lands straight with the organising team."
          align="center"
        />

        <div className="card-luxe gold-frame p-10 sm:p-14 rounded-sm text-center relative overflow-hidden">
          <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.18),transparent_70%)] pointer-events-none" />

          <div className="mx-auto w-16 h-16 grid place-items-center border border-[#D4AF37] text-[#F3E08A] rounded-full mb-6 relative">
            <PartyPopper size={24} />
          </div>

          <h3 className="font-serif-luxe text-3xl sm:text-4xl text-[#F8F1DC] leading-tight">
            Please confirm your attendance
          </h3>
          <p className="mt-4 text-[#E0D5B8] text-sm sm:text-base max-w-xl mx-auto leading-relaxed">
            Tap the button below to open our Microsoft Forms RSVP. It takes
            under a minute — you can share your dietary needs right there.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6 text-xs sm:text-sm text-[#E0D5B8]">
            <div className="inline-flex items-center gap-2">
              <Calendar size={14} className="text-[#F3E08A]" />
              <span data-testid="rsvp-cta-date">{EVENT.date}</span>
            </div>
            <span className="hidden sm:inline text-[#9F7E30]">·</span>
            <div className="inline-flex items-center gap-2">
              <MapPin size={14} className="text-[#F3E08A]" />
              <span data-testid="rsvp-cta-venue">{EVENT.venue}</span>
            </div>
          </div>

          <a
            data-testid="rsvp-cta-forms-link"
            href={RSVP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-gold inline-flex items-center gap-3 px-10 py-4 rounded-sm text-[12px] mt-10"
          >
            RSVP on Microsoft Forms
            <ArrowUpRight size={16} />
          </a>

          <div className="mt-8 text-xs text-[#A5BCB1] font-serif-luxe italic">
            Opens in a new tab · powered by Microsoft Forms
          </div>
        </div>
      </div>
    </section>
  );
}
